import { render } from "./clinic-dashboard.vue?vue&type=template&id=d32b7ae6&scoped=true"
import script from "./clinic-dashboard.vue?vue&type=script&lang=js"
export * from "./clinic-dashboard.vue?vue&type=script&lang=js"

import "./clinic-dashboard.vue?vue&type=style&index=0&id=d32b7ae6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32b7ae6"]])

export default __exports__